import {useMemo} from 'react';
import {CONSTANTS} from '../constants';

// Module-level cache for translations
let cachedTranslations = null;

// Sanitize a bad "null" string stored by a previous JSON.stringify(null) call
(function sanitizeStoredTranslations() {
  const stored = localStorage.getItem('translation');
  if (stored === 'null' || stored === 'undefined') {
    localStorage.removeItem('translation');
  }
})();

// Export function to clear cache when language changes
export const clearTranslationCache = () => {
  cachedTranslations = null;
};

const useTranslations = () => {
  const loadAllTranslations = async (lan = 'en') => {
    try {
      // Extract value
      const languageCode = typeof lan === 'object' ? lan.value : lan;
      const response = await fetch(`/locales/${languageCode}.json`);
      const data = await response.json();
      localStorage.setItem('translation', JSON.stringify(data));
      // Clear cache after loading new translations
      clearTranslationCache();
      // window.location.reload();
    } catch (error) {
      console.error('Error loading translation files:', error);
    }
  };

  const translate = useMemo(() => {
    // Parse only if cache is empty
    if (!cachedTranslations) {
      const storedTranslations = localStorage.getItem('translation');
      const parsed = storedTranslations ? JSON.parse(storedTranslations) : null;
      cachedTranslations = (parsed && typeof parsed === 'object') ? parsed : {};
    }

    return (key) => (cachedTranslations && cachedTranslations[key]) || key;
  }, []); // Empty dependency array - cache for lifetime

  const switchLanguage = lang => {
    const selectedLang = CONSTANTS.LANG[lang];
    // Store selected language and direction
    localStorage.setItem('selectedLang', selectedLang.value);
    localStorage.setItem('direction', selectedLang.value === 'ur' ? 'rtl' : 'ltr');
    // Apply changes before reload
    document.documentElement.setAttribute('lang', selectedLang.value);
    document.documentElement.setAttribute('dir', selectedLang.value === 'ur' ? 'rtl' : 'ltr');

    // loadAllTranslations(selectedLang.value);
    loadAllTranslations(selectedLang.value).then(() => {
      clearTranslationCache(); // Clear cache before reload
      window.location.reload(); // Ensure UI updates instantly
    });
  };

  return {loadAllTranslations, translate, switchLanguage};
};

export default useTranslations;
